export const ERROR_CODES = {
  BAD_REQUEST: 400,
  UNAUTHORIZED_ERROR: 401,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUEST: 429,
  INTERNAL_SERVER_ERROR: 500,
  NOT_FOUND: 404,
  GATEWAY_TIME_OUT: 504,
};

export const ERROR_DETAIL_CODES = {
  NOT_MATCH_DATA_CUSTOMER: 'NOT_MATCH_DATA_CUSTOMER',
  NOT_MATCH_PHONE_NUMBER: 'NOT_MATCH_PHONE_NUMBER',
  NOT_MATCH_LICENSE_PLATE: 'NOT_MATCH_LICENSE_PLATE',
  VALIDATE_UPDATE_PHONE_NUMBER_LIMIT_EXCEEDED:
    'VALIDATE_UPDATE_PHONE_NUMBER_LIMIT_EXCEEDED',
  PHONE_NUMBER_ALREADY_EXIST: 'PHONE_NUMBER_ALREADY_EXIST',
  NOT_MATCH_OTP: 'NOT_MATCH_OTP',
  VALIDATE_OTP_LIMIT_EXCEEDED: 'VALIDATE_OTP_LIMIT_EXCEEDED',
  RESEND_OTP_LIMIT_EXCEEDED: 'RESEND_OTP_LIMIT_EXCEEDED',
  TOO_MANY_ATTEMPT: 8,
  DOMICILE_OUT_OF_COVERAGE: 'DOMICILE_OUT_OF_COVERAGE',
  VERIFY_KTP_EXCEED_LIMIT: 'VERIFY_KTP_EXCEED_LIMIT',
  OVER_MAX_AGE_APPLICANT: 'OVER_MAX_AGE_APPLICANT',
  COLLABORATION_ALREADY_INSERT_BY_SURVEYOR:
    'COLLABORATION_ALREADY_INSERT_BY_SURVEYOR',
  GEOLOCATION_TIMEOUT: 'GEOLOCATION_TIMEOUT',
  GEOLOCATION_CLIENT_ERROR: 'GEOLOCATION_CLIENT_ERROR',
  GEOLOCATION_GATEWAY_TIMEOUT: 'GEOLOCATION_GATEWAY_TIMEOUT',
  AGENT_NOT_FOUND: 'AGENT_NOT_FOUND',
  NOT_MATCH_PHONE_NUMBER_EXCEPTION: 'NOT_MATCH_PHONE_NUMBER_EXCEPTION',
  NOT_ALLOWED_REVIVE_EXPIRED: 'NOT_ALLOWED_REVIVE_EXPIRED',
  NOT_ALLOWED_REVIVE_EXCEED_LIMIT: 'NOT_ALLOWED_REVIVE_EXCEED_LIMIT',
  NOT_ALLOWED_LOS_REVIVE: 'NOT_ALLOWED_LOS_REVIVE',
};

export const ERROR_TYPES = {
  TOO_MANY_ATTEMPT: 'TOO_MANY_ATTEMPT',
  WRONG_OTP: 'WRONG_OTP',
};

export const LOCAL_BASE_URL = 'http://localhost:3000';
